export function PageContent({className = '',children}) {
  return <div className={`page-content ${className}`}>
    {children}
  </div>
}